import { APIResponse } from '../../../../@types/api-response';
import { orderbookEndpoint } from '../constants/apiEndpoint';
import { OrderbookCompaniesResponseV2 } from '../types/api/orderbook';
import { exodusApiInstance } from './instance/exodus';

export const getOrderbookCompanies = (
  symbol: string,
): Promise<APIResponse<OrderbookCompaniesResponseV2>> =>
  exodusApiInstance.defaultInstance.get(
    orderbookEndpoint.orderbookCompanies(symbol),
  );
